import { api } from "./api";

export const getModelo = (numeroPagina: string) =>
  api.get(`Modelo/buscartodos/${numeroPagina}`);
  export const getModeloCd = (cd: number) => api.get(`Modelo/buscar/${cd}`);
export const getTodosModelos = async () => {
  try {
    const response = await api.get(`Modelo/select`)
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
